import { Platform } from 'react-native'

const useNativeDriver = Platform.OS !== 'web'

export default useNativeDriver
